"use client";
import { useState } from "react";

const CustomTabs = ({ tabs, defaultActiveTab, onTabChange }) => {
  const [activeTab, setActiveTab] = useState(defaultActiveTab || tabs[0]?.id);
  const activeTabContent = tabs.find((tab) => tab.id === activeTab)?.content;

  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
    onTabChange?.(tabId);
  };

  return (
    <div className="!w-full" style={{ position: "relative", minHeight: "200px" }}>
      <div className="tabwrapper">
        <div
          className="custom-tabs-container overflow-x-auto md:!overscroll-x-none !w-fit"
          style={{ position: "relative", zIndex: 1 }}
        >
          {tabs.map((tab) => (
            <div
              key={tab.id}
              onClick={() => handleTabClick(tab.id)}
              className={`custom-tab ${activeTab === tab.id ? "active" : ""}`}
            >
              <span className="font-medium text-[12px] md:text-[18px] whitespace-nowrap !px-[1rem] md:!px-[2rem] !py-[0.5rem]">
                {tab.label}
              </span>
            </div>
          ))}
        </div>
      </div>
      <div className="custom-tab-content">{activeTabContent}</div>
    </div>
  );
};

export default CustomTabs;
